import styled from "styled-components";

export const Wrapper = styled.div`
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  gap: 15px;
  width: 100%;

  form {
    display: flex;
    flex-direction: column;
    gap: 15px;
    width: 100%;
  }
`;

export const Section = styled.div`
  display: grid;
  grid-template-columns: auto 1fr;
  align-items: center;
  gap: 10px;

  margin-top: 20px;

  span {
    font-size: 18px;
    font-weight: 700;
    color: ${({ theme }) => theme.colors.primary.vividCerulean};
  }

  hr {
    border: 1px solid ${({ theme }) => theme.colors.primary.vividCerulean};
    width: 100%;
  }
`;

export const Messages = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  gap: 20px;

  width: 100%;
  max-width: 700px;

  padding: 10px;
  border: 2px solid ${({ theme }) => theme.colors.neutral.gray2};

  max-height: 500px;
  overflow-y: auto;
  overflow-x: hidden;

  margin-bottom: 20px;
`;

export const AuditButtons = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  width: 100%;
`;

export const Buttons = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
`;

export const File = styled.div`
  display: flex;
  gap: 5px;
  align-items: center;
  width: 100%;

  span {
    color: ${({ theme }) => theme.colors.primary.vividCerulean};
  }
`;

export const HiddenInput = styled.input`
  display: none;
`;

export const Row = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  width: 100%;
  gap: 10px;
`;

export const Info = styled.div`
  display: flex;
  flex-direction: column;
  gap: 5px;

  width: 100%;

  margin-bottom: 20px;

  span {
    font-size: 16px;
  }
`;

export const Message = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: space-between;
  gap: 10px;

  position: relative;

  justify-self: ${({ isOwn }) => (isOwn ? "flex-end" : "flex-start")};

  width: fit-content;
  min-width: 200px;
  max-width: 80%;

  padding: 10px;

  border: ${({ theme, isOwn }) =>
    isOwn ? "none" : `2px solid ${theme.colors.neutral.gray3}`};

  background-color: ${({ theme, isOwn }) =>
    isOwn ? theme.colors.neutral.gray3 : theme.colors.neutral.gray2};

  opacity: ${({ active }) => (active ? 1 : 0.5)};

  hr {
    border: 1px solid ${({ theme }) => theme.colors.primary.vividCerulean};
    width: 100%;
  }
`;

export const MessageStatus = styled.span`
  font-size: 14px;
  font-weight: 700;

  display: ${({ status }) => (status === "Aprovada" ? "none" : "block")};

  color: ${({ theme }) => theme.colors.neutral.gray8};
`;

export const MessageInfos = styled.div`
  display: flex;
  flex-direction: column;
  gap: 5px;

  width: 100%;

  h2 {
    font-size: 16px;
  }

  span {
    font-size: 14px;
  }
`;

export const MessageFile = styled.a`
  font-size: 14px;
  color: ${({ theme }) => theme.colors.neutral.black};
  font-weight: 700;

  text-decoration: underline;
`;

export const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;

  h2 {
    font-size: 16px;
    color: ${({ theme }) => theme.colors.neutral.white};
    font-weight: 700;
  }

  p {
    color: ${({ theme }) => theme.colors.neutral.cinza600};
  }
`;
